export const OPEN_CHAT = 'OPEN_CHAT'
export const CLOSE_CHAT = 'CLOSE_CHAT'
export const MAXIMIZE_CHAT = 'MAXIMIZE_CHAT'
export const MINIMIZE_CHAT = 'MINIMIZE_CHAT'
export const SET_EMOTION = 'SET_EMOTION'
export const SET_INPUT_ENABLED = 'SET_INPUT_ENABLED'
export const SET_FILE_UPLOAD_ENABLED = 'SET_FILE_UPLOAD_ENABLED'
export const START_CONVERSATION = 'START_CONVERSATION'
export const CLOSE_CONVERSATION = 'CLOSE_CONVERSATION'
export const STARTED_CONVERSATION = 'STARTED_CONVERSATION'
export const CLOSED_CONVERSATION = 'CLOSED_CONVERSATION'
export const ACCEPT_DATA_PROCESSING_CONSENT_DIALOG =
  'ACCEPT_DATA_PROCESSING_CONSENT_DIALOG'

export const SET_USER_INPUT_TEXT = 'SET_USER_INPUT'

export const SET_LOCALE = 'SET_LANGUAGE'
export const SET_SPEECH = 'SET_SPEECH'
export const SET_EDIT_MESSAGE = 'SET_EDIT_MESSAGE'

export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'

export const TOGGLE_SHOW_SYSTEM_MESSAGES = 'TOGGLE_DEBUG'

export const ADD_MESSAGE = 'ADD_MESSAGE'
export const ADD_MESSAGES = 'ADD_MESSAGES'
export const ADD_SOCKET_MESSAGE = 'ADD_SOCKET_MESSAGE'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'

export const SOCKET_EMIT_NEW_USER_MESSAGE = 'SOCKET_EMIT_NEW_USER_MESSAGE'
export const SOCKET_ON_CONNECT = 'SOCKET_ON_CONNECT'
export const SOCKET_ON_SESSION_CONFIRM = 'SOCKET_ON_SESSION_CONFIRM'
export const SOCKET_ON_LANGUAGE_CHANGE = 'SOCKET_ON_LANGUAGE_CHANGE'
export const SOCKET_ON_CONNECT_ERROR = 'SOCKET_ON_CONNECT_ERROR'
export const SOCKET_ON_RECONNECT_ATTEMPTS = 'SOCKET_ON_RECONNECT_ATTEMPTS'
export const SOCKET_ON_ERROR = 'SOCKET_ON_ERROR'
export const SOCKET_ON_DISCONNECT = 'SOCKET_ON_DISCONNECT'
export const SOCKET_ON_MESSAGE = 'SOCKET_ON_MESSAGE'
export const SOCKET_ON_JOIN_CONFIRM = 'SOCKET_ON_JOIN_CONFIRM'
export const SOCKET_ON_LEAVE_CONFIRM = 'SOCKET_ON_LEAVE_CONFIRM'
export const SOCKET_ON_OPERATOR_TYPING = 'SOCKET_ON_OPERATOR_TYPING'

export const IS_RESTRICTED = 'IS_RESTRICTED'
export const CLEAR_FILES = 'CLEAR_FILES'

export const SET_BACK_BUTTON_ENABLED = 'SET_BACK_BUTTON_ENABLED'
export const SET_BACK_INPUT_DISABLED = 'SET_BACK_INPUT_DISABLED'
export const SHOW_PROACTIVE_MESSAGE = 'SHOW_PROACTIVE_MESSAGE'
export const SET_POST_MESSAGE_TARGET = 'SET_POST_MESSAGE_TARGET'
export const SET_CONVERSATION_PDF_REQUESTED = 'SET_CONVERSATION_PDF_REQUESTED'
export const SET_PDF_DOWNLOAD_ENABLED = 'SET_PDF_DOWNLOAD_ENABLED'
export const SET_PARENT_WINDOW_SIZE = 'SET_PARENT_WINDOW_SIZE'

export const SET_SEMANTIC_SUGGESTIONS_ENABLED =
  'SET_SEMANTIC_SUGGESTIONS_ENABLED'
